// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2kcOU","choiceBoxes":"toolbarselects_choiceBoxes__2yIxe","simpleField":"toolbarselects_simpleField__nlpZT"};